import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {


      dashboard: "Dashboard",


      reports: "Reports",
      dailySalesReport: "Daily Sales Report",

      //Setting Page
      settings: "Settings",
      selectLanguage: "Select Language",
      permissions: "Permissions",
      addPermissions: "Add Permissions",
      addUser: "Add User",
    },
  },
  ur: {
    translation: {
      dashboard: "ڈیش بورڈ",

      //setting page
      settings: "ترتیبات",
      selectLanguage: "زبان منتخب کریں",
      permissions: "اجازتیں",
      addPermissions: "اجازتیں شامل کریں",
      addUser: "صارف شامل کریں",

      reports: "Reports",
      dailySalesReport: "Daily Sales Report",

    },
  },
  ar: {
    translation: {

      dashboard: "لوحة القيادة",

      //setting page
      settings: "الإعدادات",
      selectLanguage: "اختر اللغة",
      permissions: "الأذونات",
      addPermissions: "إضافة أذونات",
      addUser: "إضافة مستخدم",


      reports: "Reports",
      dailySalesReport: "Daily Sales Report",

    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
